import { ContentDialog } from '@spark-web/modal-dialog';
import { FormProvider, useForm } from 'react-hook-form';

import { Footer } from '~/components/footer';
import { RequestQuoteForm } from '~/components/form/request-quote-form';
import { useModal } from '~/hooks/useModal';
import { CustomerFormValues } from '~/types/marketplace';

import { useLeadCreationFetcher } from './hooks/useLeadCreationFetcher';

type SelectedVendorProps = {
  onRequestQuotes: () => void;
};

export const SelectedVendor = ({ onRequestQuotes }: SelectedVendorProps) => {
  const { close, onCloseAutoFocus, isOpen } = useModal('selected-vendor');

  const { onSubmit, isLoading, error, lead, postcode, selectedCategories } = useLeadCreationFetcher({
    onRequestQuotes,
    close,
  });

  const isCustomerFormFieldRequired = !lead && postcode !== '' && (selectedCategories?.length ?? 0) > 0;

  const formMethods = useForm<CustomerFormValues>({
    mode: 'all',
  });

  return (
    <ContentDialog
      title="Brighte Marketplace"
      showCloseButton={!isCustomerFormFieldRequired}
      isOpen={isOpen}
      onToggle={() => {
        if (!isCustomerFormFieldRequired) close();
      }}
      onCloseAutoFocus={onCloseAutoFocus}
    >
      <FormProvider {...formMethods}>
        <RequestQuoteForm
          isLoading={isLoading}
          onSubmit={onSubmit}
          error={error}
          isAddVendorFlow
          leadType="Marketplace"
        />
        <Footer />
      </FormProvider>
    </ContentDialog>
  );
};
